class AnnouncementBar extends HTMLElement {
    constructor() {
        super();

        setTimeout(() => {
            const slideCount = this.querySelectorAll("#AnnouncementBar-splide li").length;
            const splideElem = this.querySelector("#AnnouncementBar-splide");
            this.splide = new Splide(splideElem, {
                type: "fade",
                pagination: false,
                rewind: true,
                arrows: slideCount > 1,
                drag: slideCount > 1
            });
            this.splide.mount();
        }, 10);
    }

    goToSlide(slideNum) {
        this.splide.go(slideNum);
    }
}

customElements.define("announcement-bar", AnnouncementBar);
